<app-layout>
  <ngx-spinner></ngx-spinner>
  <router-outlet></router-outlet>
</app-layout>
